<div class="modal-header">
	<button type="button" class="close" data-dismiss="modal">×</button>
	<h4 class="modal-title">{{TR "Freigabe für vor-Ort-Konfiguration"}}</h4>
</div>
<div class="modal-body">
	<div class="wizard-header two clearfix">
		<ul class="steps">
			<li class="first {{#COMPARE activeTab '==' 1}}current{{else}}done{{/COMPARE}}">
				<div>
					<span class="number">1.</span> {{TR "Bestätigung"}}
				</div>
			</li>

			<li class="last {{#COMPARE activeTab '==' 1}}disabled{{else}}current{{/COMPARE}}">
				<div>
					<span class="number">2.</span> {{TR "PIN"}}
				</div>
			</li>
		</ul>
	</div>
	{{#COMPARE activeTab '==' 1}}
	<div class="m-t-20">
		<p>{{TR "Zur Freigabe der vor-Ort-Konfiguration wird eine 6-stellige PIN generiert. Eine eventuell noch aktive PIN wird überschrieben."}}</p>
		<p>{{{TR "Diese PIN kann nach der Freigabe für <b>3 Stunden</b> verwendet werden um vor Ort den Gatewaykonfigurator mit dem Gateway zu verbinden."}}}</p>
		<p>{{TR "Nach Ablauf dieser Frist muss eine neue PIN generiert werden, um den Zugriff vor Ort zu ermöglichen."}}</p>
	</div>
	<textarea type="text" class="m-t-30 form-control input-field-note-fixed" id="js-note-input" name="note" placeholder="{{TR "Anmerkung (optional), z.B. Auftragsnummer, Freigabegrund, etc."}}" maxlength="100"/>
	{{else}}
	<div class="m-t-20">
		<p>{{TR "Ihre PIN für die vor-Ort-Konfiguration wurde erfolgreich generiert:"}}</p>

		<p class="m-t-10 m-b-10"><center>
			<h1><b>{{num1}} {{num2}}</b></h1>
		</center></p>

		<p>{{TR "Diese PIN ist gültig bis"}} {{expirationDate}} {{TR "Uhr"}}.</p>

		<p>{{TR "Hinweis"}}: {{TR "Wenn Sie den Dialog schließen, kann die PIN nicht erneut angezeigt werden."}}</p>
	</div>
	{{/COMPARE}}
</div>
<div class="modal-footer">
	<button id="ct-cancel" class="btn btn-white" data-dismiss="modal">
	{{#COMPARE activeTab '==' 1}}
	{{TR "Abbrechen"}}</button>
	<button class="btn btn-primary" id="js-next">
		{{TR "Gerät freigeben"}} <i class="glyphicon glyphicon-chevron-right"></i>
	</button>
	{{else}}
	{{TR "Schließen"}}</button>
	{{/COMPARE}}
</div>
